import React from 'react';

const ParametreContext = React.createContext({
  typeCouleur: null, // Statut, activé ou réservant
  couleurParticulier: null,
});

export default ParametreContext;
